import store from 'Store';
import { onResponseError, checkResponsesOnRedirect } from 'Router/dependency-manager/resolve-store';

async function registerStoreModule(to, from, next) {
  const { default: storeModule } = await import(/* webpackChunkName: 'storeModuleLearningCenter' */ '../store');
  if (!store.hasModule('learningCenter')) {
    store.registerModule('learningCenter', storeModule);
  }
  next();
}

export default [
  {
    path: '/learn',
    name: 'learn',
    component: () => import(/* webpackChunkName: 'PageLearningCenterGeneral' */ '../PageLearningCenterGeneral'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['learningCenter/getLearnCategoryList', 'learningCenter/getLearnData', 'learningCenter/getLearnMostPopularData'],
    },
  },
  {
    path: '/learn/search',
    name: 'learn-search',
    component: () => import(/* webpackChunkName: 'PageLearningCenterSearch' */ '../PageLearningCenterSearch'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['learningCenter/getLearnCategoryList'],
    },
    children: [
      {
        path: ':searchQuery',
        name: 'learn-search-query',
        meta: {
          resolve(to) {
            return store.dispatch('learningCenter/getLearnSearchResult', to.params.searchQuery);
          },
        },
      },
    ],
  },
  {
    path: '/learn/author/:slug',
    name: 'learn-author',
    component: () => import(/* webpackChunkName: 'PageLearningCenterAuthor' */ '../PageLearningCenterAuthor'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['learningCenter/getLearnCategoryList', 'learningCenter/getLearnAuthorData'],
    },
  },
  {
    path: '/learn/tag/:slug',
    name: 'learn-tag',
    component: () => import(/* webpackChunkName: 'PageLearningCenterTag' */ '../PageLearningCenterTag'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['learningCenter/getLearnCategoryList', 'learningCenter/getLearnTagData'],
    },
  },
  {
    path: '/learn/topic/:slug',
    redirect(to) {
      return { ...to, name: 'learn-category' };
    },
  },
  {
    path: '/learn/:categorySlug/:slug',
    name: 'learn-post',
    component: () => import(/* webpackChunkName: 'PageLearningCenterSingle' */ '../PageLearningCenterSingle'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['learningCenter/getLearnCategoryList', 'learningCenter/getLearnPostData'],
      updateStoreData: true,
    },
  },
  {
    path: '/learn/:slug',
    name: 'learn-category',
    component: () => import(/* webpackChunkName: 'PageLearningCenterCategory' */ '../PageLearningCenterCategory'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['learningCenter/getLearnCategoryList'],
      async resolve(to, from, next) {
        // handle redirect inside content
        try {
          const learnCategoryData = await store.dispatch(
            'learningCenter/getLearnCategoryData',
            { slug: to.params.slug, skipSetToStore: true },
          );
          await checkResponsesOnRedirect([learnCategoryData], to, from, next);
          const learnCategoryMostPopularData = await store.dispatch(
            'learningCenter/getLearnCategoryMostPopularData',
            { slug: to.params.slug, skipSetToStore: true },
          );
          // wait to load all content which needed and then set it to avoid blinks content
          await store.dispatch('learningCenter/setAll', { learnCategoryData, learnCategoryMostPopularData });
        } catch (error) {
          if (error?.response?.status === 404) {
            try {
              const postData = await store.dispatch('learningCenter/getLearnPostData', { slug: to.params.slug });
              next({ name: 'learn-post', params: { categorySlug: postData.category?.slug, slug: postData.slug } });
            } catch (postLoadError) {
              onResponseError(error, to, from, next);
            }
          } else {
            onResponseError(error, to, from, next);
          }
        }
      },
    },
  },
];
